export const payTranslations = {
  en: {
    'pay.pageTitle': 'Create Payment',
    'pay.pageTitleRecipient': 'Pay {{name}}',
    'pay.loadingPayee': 'Loading payee information...',
    'pay.merchantNotInMarketplace': 'Merchant not found in marketplace',
    'pay.paymentCurrency': 'Payment Currency',
    'pay.orderSummary': 'Order Summary',
    'pay.paymentComplete': 'Payment Complete',
    'pay.paymentDeliveredSuccessfully': 'Payment Delivered Successfully',
    'pay.paymentDeliveredToInbox': 'Payment Delivered to Inbox',
    'pay.recentlyCreatedInvoice': 'Recently Created Invoice',
    'pay.recentlyCreatedToken': 'Recently Created Token',
    'pay.paymentDeliveredTo': 'Payment delivered to {{name}}',
    'pay.yourPaymentDelivered': 'Your payment of {{amount}} {{currency}} has been delivered to {{name}}',
    'pay.recipientWillReview': '{{name}} will review and accept your payment',
    'pay.invoiceCreatedSuccessfully': 'Invoice created successfully',
    'pay.tokenCreatedSuccessfully': 'Token created successfully',
    'pay.paymentSuccessful': 'Payment Successful',
    'pay.makeAnotherPayment': 'Make Another Payment',
    'pay.paymentInInbox': 'Payment in Inbox',
    'pay.recipientHasControl': '{{name}} has control over when to accept this payment',
    'pay.paymentDeposited': 'Payment Deposited',
    'pay.yourPaymentDepositedTo': 'Your payment of {{amount}} {{currency}} has been deposited to {{name}}',
    'pay.messageSentWithPayment': 'Message sent with payment',
    'pay.autoPaymentMode.title': 'Auto Payment Mode',
    'pay.autoPaymentMode.creatingTokenFor': 'Creating token for {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token sent to parent window',
    'pay.security.title': 'Security Features',
    'pay.security.bankLevelEncryption': 'Bank-Level Encryption',
    'pay.security.bankLevelEncryptionDesc': 'All transactions are protected with industry-standard encryption',
    'pay.security.multiplePaymentOptions': 'Multiple Payment Options',
    'pay.security.multiplePaymentOptionsDesc': 'Choose from cards, bank accounts, PayPal, and more',
    'pay.security.pciCompliant': 'PCI Compliant',
    'pay.security.pciCompliantDesc': 'We meet the highest security standards for payment processing',
    'pay.continueOnMobile': 'Continue on Mobile',
    'pay.continueOnMobileDesc': 'Scan the QR code with your phone to complete payment on mobile',
    'pay.usePhoneCamera': 'Use your phone camera to scan the QR code',
    'pay.guestCheckout.title': 'Guest Checkout Available',
    'pay.guestCheckout.description': 'Continue as a guest to make payments without creating an account',
  },
  es: {
    'pay.pageTitle': 'Crear Pago',
    'pay.pageTitleRecipient': 'Pagar a {{name}}',
    'pay.loadingPayee': 'Cargando información del beneficiario...',
    'pay.merchantNotInMarketplace': 'Comerciante no encontrado en el mercado',
    'pay.paymentCurrency': 'Moneda de Pago',
    'pay.orderSummary': 'Resumen del Pedido',
    'pay.paymentComplete': 'Pago Completado',
    'pay.paymentDeliveredSuccessfully': 'Pago Entregado Exitosamente',
    'pay.paymentDeliveredToInbox': 'Pago Entregado a la Bandeja de Entrada',
    'pay.recentlyCreatedInvoice': 'Factura Creada Recientemente',
    'pay.recentlyCreatedToken': 'Token Creado Recientemente',
    'pay.paymentDeliveredTo': 'Pago entregado a {{name}}',
    'pay.yourPaymentDelivered': 'Tu pago de {{amount}} {{currency}} ha sido entregado a {{name}}',
    'pay.recipientWillReview': '{{name}} revisará y aceptará tu pago',
    'pay.invoiceCreatedSuccessfully': 'Factura creada exitosamente',
    'pay.tokenCreatedSuccessfully': 'Token creado exitosamente',
    'pay.paymentSuccessful': 'Pago Exitoso',
    'pay.makeAnotherPayment': 'Hacer Otro Pago',
    'pay.paymentInInbox': 'Pago en Bandeja de Entrada',
    'pay.recipientHasControl': '{{name}} tiene control sobre cuándo aceptar este pago',
    'pay.paymentDeposited': 'Pago Depositado',
    'pay.yourPaymentDepositedTo': 'Tu pago de {{amount}} {{currency}} ha sido depositado a {{name}}',
    'pay.messageSentWithPayment': 'Mensaje enviado con el pago',
    'pay.autoPaymentMode.title': 'Modo de Pago Automático',
    'pay.autoPaymentMode.creatingTokenFor': 'Creando token para {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token enviado a la ventana principal',
    'pay.security.title': 'Características de Seguridad',
    'pay.security.bankLevelEncryption': 'Cifrado de Nivel Bancario',
    'pay.security.bankLevelEncryptionDesc': 'Todas las transacciones están protegidas con cifrado estándar de la industria',
    'pay.security.multiplePaymentOptions': 'Múltiples Opciones de Pago',
    'pay.security.multiplePaymentOptionsDesc': 'Elige entre tarjetas, cuentas bancarias, PayPal y más',
    'pay.security.pciCompliant': 'Cumplimiento PCI',
    'pay.security.pciCompliantDesc': 'Cumplimos con los más altos estándares de seguridad para el procesamiento de pagos',
    'pay.continueOnMobile': 'Continuar en Móvil',
    'pay.continueOnMobileDesc': 'Escanea el código QR con tu teléfono para completar el pago en móvil',
    'pay.usePhoneCamera': 'Usa la cámara de tu teléfono para escanear el código QR',
    'pay.guestCheckout.title': 'Pago de Invitado Disponible',
    'pay.guestCheckout.description': 'Continúa como invitado para realizar pagos sin crear una cuenta',
  },
  fr: {
    'pay.pageTitle': 'Créer un Paiement',
    'pay.pageTitleRecipient': 'Payer {{name}}',
    'pay.loadingPayee': 'Chargement des informations du bénéficiaire...',
    'pay.merchantNotInMarketplace': 'Marchand introuvable sur le marché',
    'pay.paymentCurrency': 'Devise de Paiement',
    'pay.orderSummary': 'Résumé de la Commande',
    'pay.paymentComplete': 'Paiement Terminé',
    'pay.paymentDeliveredSuccessfully': 'Paiement Livré avec Succès',
    'pay.paymentDeliveredToInbox': 'Paiement Livré dans la Boîte de Réception',
    'pay.recentlyCreatedInvoice': 'Facture Créée Récemment',
    'pay.recentlyCreatedToken': 'Token Créé Récemment',
    'pay.paymentDeliveredTo': 'Paiement livré à {{name}}',
    'pay.yourPaymentDelivered': 'Votre paiement de {{amount}} {{currency}} a été livré à {{name}}',
    'pay.recipientWillReview': '{{name}} examinera et acceptera votre paiement',
    'pay.invoiceCreatedSuccessfully': 'Facture créée avec succès',
    'pay.tokenCreatedSuccessfully': 'Token créé avec succès',
    'pay.paymentSuccessful': 'Paiement Réussi',
    'pay.makeAnotherPayment': 'Effectuer un Autre Paiement',
    'pay.paymentInInbox': 'Paiement dans la Boîte de Réception',
    'pay.recipientHasControl': '{{name}} a le contrôle sur le moment d\'accepter ce paiement',
    'pay.paymentDeposited': 'Paiement Déposé',
    'pay.yourPaymentDepositedTo': 'Votre paiement de {{amount}} {{currency}} a été déposé à {{name}}',
    'pay.messageSentWithPayment': 'Message envoyé avec le paiement',
    'pay.autoPaymentMode.title': 'Mode de Paiement Automatique',
    'pay.autoPaymentMode.creatingTokenFor': 'Création d\'un token pour {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token envoyé à la fenêtre parente',
    'pay.security.title': 'Caractéristiques de Sécurité',
    'pay.security.bankLevelEncryption': 'Chiffrement de Niveau Bancaire',
    'pay.security.bankLevelEncryptionDesc': 'Toutes les transactions sont protégées par un chiffrement de niveau industrie',
    'pay.security.multiplePaymentOptions': 'Plusieurs Options de Paiement',
    'pay.security.multiplePaymentOptionsDesc': 'Choisissez parmi les cartes, comptes bancaires, PayPal et plus encore',
    'pay.security.pciCompliant': 'Conforme PCI',
    'pay.security.pciCompliantDesc': 'Nous respectons les normes de sécurité les plus élevées pour le traitement des paiements',
    'pay.continueOnMobile': 'Continuer sur Mobile',
    'pay.continueOnMobileDesc': 'Scannez le code QR avec votre téléphone pour compléter le paiement sur mobile',
    'pay.usePhoneCamera': 'Utilisez l\'appareil photo de votre téléphone pour scanner le code QR',
    'pay.guestCheckout.title': 'Paiement Invité Disponible',
    'pay.guestCheckout.description': 'Continuez en tant qu\'invité pour effectuer des paiements sans créer de compte',
  },
  sq: {
    'pay.pageTitle': 'Krijo Pagesë',
    'pay.pageTitleRecipient': 'Paguaj {{name}}',
    'pay.loadingPayee': 'Duke ngarkuar informacionin e përfituesit...',
    'pay.merchantNotInMarketplace': 'Tregtari nuk u gjet në treg',
    'pay.paymentCurrency': 'Valuta e Pagesës',
    'pay.orderSummary': 'Përmbledhje e Porosisë',
    'pay.paymentComplete': 'Pagesa e Plotësuar',
    'pay.paymentDeliveredSuccessfully': 'Pagesa Dorëzuar me Sukses',
    'pay.paymentDeliveredToInbox': 'Pagesa Dorëzuar në Kutinë e Postës',
    'pay.recentlyCreatedInvoice': 'Faturë e Krijuar Së Fundmi',
    'pay.recentlyCreatedToken': 'Token i Krijuar Së Fundmi',
    'pay.paymentDeliveredTo': 'Pagesa u dorëzua te {{name}}',
    'pay.yourPaymentDelivered': 'Pagesa juaj prej {{amount}} {{currency}} u dorëzua te {{name}}',
    'pay.recipientWillReview': '{{name}} do të shqyrtojë dhe pranojë pagesën tuaj',
    'pay.invoiceCreatedSuccessfully': 'Fatura u krijua me sukses',
    'pay.tokenCreatedSuccessfully': 'Tokeni u krijua me sukses',
    'pay.paymentSuccessful': 'Pagesa e Suksesshme',
    'pay.makeAnotherPayment': 'Bëj Një Pagesë Tjetër',
    'pay.paymentInInbox': 'Pagesa në Kutinë e Postës',
    'pay.recipientHasControl': '{{name}} ka kontroll mbi kur të pranojë këtë pagesë',
    'pay.paymentDeposited': 'Pagesa e Depozituar',
    'pay.yourPaymentDepositedTo': 'Pagesa juaj prej {{amount}} {{currency}} u depozitua te {{name}}',
    'pay.messageSentWithPayment': 'Mesazhi u dërgua me pagesën',
    'pay.autoPaymentMode.title': 'Modaliteti i Pagesës Automatike',
    'pay.autoPaymentMode.creatingTokenFor': 'Duke krijuar token për {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Tokeni u dërgua në dritaren mëmë',
    'pay.security.title': 'Karakteristikat e Sigurisë',
    'pay.security.bankLevelEncryption': 'Kriptimi i Nivelit Bankar',
    'pay.security.bankLevelEncryptionDesc': 'Të gjitha transaksionet janë të mbrojtura me kriptim të standardit të industrisë',
    'pay.security.multiplePaymentOptions': 'Opsione të Shumta Pagese',
    'pay.security.multiplePaymentOptionsDesc': 'Zgjidhni midis kartave, llogarive bankare, PayPal dhe më shumë',
    'pay.security.pciCompliant': 'Në Përputhje me PCI',
    'pay.security.pciCompliantDesc': 'Ne plotësojmë standardet më të larta të sigurisë për përpunimin e pagesave',
    'pay.continueOnMobile': 'Vazhdo në Mobil',
    'pay.continueOnMobileDesc': 'Skanoni kodin QR me telefonin tuaj për të plotësuar pagesën në mobil',
    'pay.usePhoneCamera': 'Përdorni kamerën e telefonit tuaj për të skanuar kodin QR',
    'pay.guestCheckout.title': 'Pagesa e Vizitorit e Disponueshme',
    'pay.guestCheckout.description': 'Vazhdoni si vizitor për të bërë pagesa pa krijuar një llogari',
  },
  ru: {
    'pay.pageTitle': 'Создать Платеж',
    'pay.pageTitleRecipient': 'Оплатить {{name}}',
    'pay.loadingPayee': 'Загрузка информации о получателе...',
    'pay.merchantNotInMarketplace': 'Продавец не найден на рынке',
    'pay.paymentCurrency': 'Валюта Платежа',
    'pay.orderSummary': 'Сводка Заказа',
    'pay.paymentComplete': 'Платеж Завершен',
    'pay.paymentDeliveredSuccessfully': 'Платеж Успешно Доставлен',
    'pay.paymentDeliveredToInbox': 'Платеж Доставлен во Входящие',
    'pay.recentlyCreatedInvoice': 'Недавно Созданный Счет',
    'pay.recentlyCreatedToken': 'Недавно Созданный Токен',
    'pay.paymentDeliveredTo': 'Платеж доставлен {{name}}',
    'pay.yourPaymentDelivered': 'Ваш платеж {{amount}} {{currency}} был доставлен {{name}}',
    'pay.recipientWillReview': '{{name}} рассмотрит и примет ваш платеж',
    'pay.invoiceCreatedSuccessfully': 'Счет успешно создан',
    'pay.tokenCreatedSuccessfully': 'Токен успешно создан',
    'pay.paymentSuccessful': 'Платеж Успешен',
    'pay.makeAnotherPayment': 'Сделать Еще Один Платеж',
    'pay.paymentInInbox': 'Платеж во Входящих',
    'pay.recipientHasControl': '{{name}} контролирует, когда принять этот платеж',
    'pay.paymentDeposited': 'Платеж Зачислен',
    'pay.yourPaymentDepositedTo': 'Ваш платеж {{amount}} {{currency}} был зачислен {{name}}',
    'pay.messageSentWithPayment': 'Сообщение отправлено с платежом',
    'pay.autoPaymentMode.title': 'Режим Автоматического Платежа',
    'pay.autoPaymentMode.creatingTokenFor': 'Создание токена для {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Токен отправлен в родительское окно',
    'pay.security.title': 'Функции Безопасности',
    'pay.security.bankLevelEncryption': 'Банковское Шифрование',
    'pay.security.bankLevelEncryptionDesc': 'Все транзакции защищены шифрованием промышленного стандарта',
    'pay.security.multiplePaymentOptions': 'Множество Вариантов Платежа',
    'pay.security.multiplePaymentOptionsDesc': 'Выберите из карт, банковских счетов, PayPal и других',
    'pay.security.pciCompliant': 'Соответствие PCI',
    'pay.security.pciCompliantDesc': 'Мы соответствуем высочайшим стандартам безопасности для обработки платежей',
    'pay.continueOnMobile': 'Продолжить на Мобильном',
    'pay.continueOnMobileDesc': 'Отсканируйте QR-код телефоном, чтобы завершить платеж на мобильном устройстве',
    'pay.usePhoneCamera': 'Используйте камеру телефона для сканирования QR-кода',
    'pay.guestCheckout.title': 'Гостевой Платеж Доступен',
    'pay.guestCheckout.description': 'Продолжите как гость для совершения платежей без создания аккаунта',
  },
  pt: {
    'pay.pageTitle': 'Criar Pagamento',
    'pay.pageTitleRecipient': 'Pagar {{name}}',
    'pay.loadingPayee': 'Carregando informações do beneficiário...',
    'pay.merchantNotInMarketplace': 'Comerciante não encontrado no mercado',
    'pay.paymentCurrency': 'Moeda do Pagamento',
    'pay.orderSummary': 'Resumo do Pedido',
    'pay.paymentComplete': 'Pagamento Completo',
    'pay.paymentDeliveredSuccessfully': 'Pagamento Entregue com Sucesso',
    'pay.paymentDeliveredToInbox': 'Pagamento Entregue na Caixa de Entrada',
    'pay.recentlyCreatedInvoice': 'Fatura Criada Recentemente',
    'pay.recentlyCreatedToken': 'Token Criado Recentemente',
    'pay.paymentDeliveredTo': 'Pagamento entregue a {{name}}',
    'pay.yourPaymentDelivered': 'Seu pagamento de {{amount}} {{currency}} foi entregue a {{name}}',
    'pay.recipientWillReview': '{{name}} revisará e aceitará seu pagamento',
    'pay.invoiceCreatedSuccessfully': 'Fatura criada com sucesso',
    'pay.tokenCreatedSuccessfully': 'Token criado com sucesso',
    'pay.paymentSuccessful': 'Pagamento Bem-sucedido',
    'pay.makeAnotherPayment': 'Fazer Outro Pagamento',
    'pay.paymentInInbox': 'Pagamento na Caixa de Entrada',
    'pay.recipientHasControl': '{{name}} tem controle sobre quando aceitar este pagamento',
    'pay.paymentDeposited': 'Pagamento Depositado',
    'pay.yourPaymentDepositedTo': 'Seu pagamento de {{amount}} {{currency}} foi depositado a {{name}}',
    'pay.messageSentWithPayment': 'Mensagem enviada com o pagamento',
    'pay.autoPaymentMode.title': 'Modo de Pagamento Automático',
    'pay.autoPaymentMode.creatingTokenFor': 'Criando token para {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token enviado para a janela pai',
    'pay.security.title': 'Recursos de Segurança',
    'pay.security.bankLevelEncryption': 'Criptografia de Nível Bancário',
    'pay.security.bankLevelEncryptionDesc': 'Todas as transações são protegidas com criptografia padrão da indústria',
    'pay.security.multiplePaymentOptions': 'Múltiplas Opções de Pagamento',
    'pay.security.multiplePaymentOptionsDesc': 'Escolha entre cartões, contas bancárias, PayPal e mais',
    'pay.security.pciCompliant': 'Compatível com PCI',
    'pay.security.pciCompliantDesc': 'Atendemos aos mais altos padrões de segurança para processamento de pagamentos',
    'pay.continueOnMobile': 'Continuar no Mobile',
    'pay.continueOnMobileDesc': 'Escaneie o código QR com seu telefone para completar o pagamento no mobile',
    'pay.usePhoneCamera': 'Use a câmera do seu telefone para escanear o código QR',
    'pay.guestCheckout.title': 'Checkout de Convidado Disponível',
    'pay.guestCheckout.description': 'Continue como convidado para fazer pagamentos sem criar uma conta',
  },
  el: {
    'pay.pageTitle': 'Δημιουργία Πληρωμής',
    'pay.pageTitleRecipient': 'Πληρωμή {{name}}',
    'pay.loadingPayee': 'Φόρτωση πληροφοριών δικαιούχου...',
    'pay.merchantNotInMarketplace': 'Ο έμπορος δεν βρέθηκε στην αγορά',
    'pay.paymentCurrency': 'Νόμισμα Πληρωμής',
    'pay.orderSummary': 'Σύνοψη Παραγγελίας',
    'pay.paymentComplete': 'Η Πληρωμή Ολοκληρώθηκε',
    'pay.paymentDeliveredSuccessfully': 'Η Πληρωμή Παραδόθηκε με Επιτυχία',
    'pay.paymentDeliveredToInbox': 'Η Πληρωμή Παραδόθηκε στα Εισερχόμενα',
    'pay.recentlyCreatedInvoice': 'Πρόσφατα Δημιουργημένη Τιμολόγηση',
    'pay.recentlyCreatedToken': 'Πρόσφατα Δημιουργημένο Διακριτικό',
    'pay.paymentDeliveredTo': 'Η πληρωμή παραδόθηκε σε {{name}}',
    'pay.yourPaymentDelivered': 'Η πληρωμή σας {{amount}} {{currency}} παραδόθηκε σε {{name}}',
    'pay.recipientWillReview': 'Ο {{name}} θα εξετάσει και θα δεχτεί την πληρωμή σας',
    'pay.invoiceCreatedSuccessfully': 'Η τιμολόγηση δημιουργήθηκε με επιτυχία',
    'pay.tokenCreatedSuccessfully': 'Το διακριτικό δημιουργήθηκε με επιτυχία',
    'pay.paymentSuccessful': 'Επιτυχής Πληρωμή',
    'pay.makeAnotherPayment': 'Κάντε Άλλη Πληρωμή',
    'pay.paymentInInbox': 'Πληρωμή στα Εισερχόμενα',
    'pay.recipientHasControl': 'Ο {{name}} έχει τον έλεγχο πότε να δεχτεί αυτή την πληρωμή',
    'pay.paymentDeposited': 'Κατατεθειμένη Πληρωμή',
    'pay.yourPaymentDepositedTo': 'Η πληρωμή σας {{amount}} {{currency}} κατατέθηκε σε {{name}}',
    'pay.messageSentWithPayment': 'Μήνυμα στάλθηκε με την πληρωμή',
    'pay.autoPaymentMode.title': 'Λειτουργία Αυτόματης Πληρωμής',
    'pay.autoPaymentMode.creatingTokenFor': 'Δημιουργία διακριτικού για {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Το διακριτικό στάλθηκε στο γονικό παράθυρο',
    'pay.security.title': 'Χαρακτηριστικά Ασφαλείας',
    'pay.security.bankLevelEncryption': 'Κρυπτογράφηση Επιπέδου Τραπεζών',
    'pay.security.bankLevelEncryptionDesc': 'Όλες οι συναλλαγές προστατεύονται με κρυπτογράφηση βιομηχανικού προτύπου',
    'pay.security.multiplePaymentOptions': 'Πολλαπλές Επιλογές Πληρωμής',
    'pay.security.multiplePaymentOptionsDesc': 'Επιλέξτε από κάρτες, τραπεζικούς λογαριασμούς, PayPal και άλλα',
    'pay.security.pciCompliant': 'Συμμόρφωση με PCI',
    'pay.security.pciCompliantDesc': 'Πληρούμε τα υψηλότερα πρότυπα ασφαλείας για την επεξεργασία πληρωμών',
    'pay.continueOnMobile': 'Συνέχεια στο Κινητό',
    'pay.continueOnMobileDesc': 'Σαρώστε τον κωδικό QR με το τηλέφωνό σας για να ολοκληρώσετε την πληρωμή στο κινητό',
    'pay.usePhoneCamera': 'Χρησιμοποιήστε την κάμερα του τηλεφώνου σας για να σαρώσετε τον κωδικό QR',
    'pay.guestCheckout.title': 'Ταμείο Επισκεπτών Διαθέσιμο',
    'pay.guestCheckout.description': 'Συνεχίστε ως επισκέπτης για να κάνετε πληρωμές χωρίς δημιουργία λογαριασμού',
  },
  de: {
    'pay.pageTitle': 'Zahlung Erstellen',
    'pay.pageTitleRecipient': '{{name}} Bezahlen',
    'pay.loadingPayee': 'Lade Zahlungsempfänger-Informationen...',
    'pay.merchantNotInMarketplace': 'Händler nicht im Marktplatz gefunden',
    'pay.paymentCurrency': 'Zahlungswährung',
    'pay.orderSummary': 'Bestellübersicht',
    'pay.paymentComplete': 'Zahlung Abgeschlossen',
    'pay.paymentDeliveredSuccessfully': 'Zahlung Erfolgreich Geliefert',
    'pay.paymentDeliveredToInbox': 'Zahlung in Posteingang Geliefert',
    'pay.recentlyCreatedInvoice': 'Kürzlich Erstellte Rechnung',
    'pay.recentlyCreatedToken': 'Kürzlich Erstellter Token',
    'pay.paymentDeliveredTo': 'Zahlung an {{name}} geliefert',
    'pay.yourPaymentDelivered': 'Ihre Zahlung von {{amount}} {{currency}} wurde an {{name}} geliefert',
    'pay.recipientWillReview': '{{name}} wird Ihre Zahlung prüfen und akzeptieren',
    'pay.invoiceCreatedSuccessfully': 'Rechnung erfolgreich erstellt',
    'pay.tokenCreatedSuccessfully': 'Token erfolgreich erstellt',
    'pay.paymentSuccessful': 'Zahlung Erfolgreich',
    'pay.makeAnotherPayment': 'Weitere Zahlung Tätigen',
    'pay.paymentInInbox': 'Zahlung im Posteingang',
    'pay.recipientHasControl': '{{name}} hat die Kontrolle darüber, wann diese Zahlung akzeptiert wird',
    'pay.paymentDeposited': 'Zahlung Eingezahlt',
    'pay.yourPaymentDepositedTo': 'Ihre Zahlung von {{amount}} {{currency}} wurde an {{name}} eingezahlt',
    'pay.messageSentWithPayment': 'Nachricht mit Zahlung gesendet',
    'pay.autoPaymentMode.title': 'Automatischer Zahlungsmodus',
    'pay.autoPaymentMode.creatingTokenFor': 'Erstelle Token für {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token an übergeordnetes Fenster gesendet',
    'pay.security.title': 'Sicherheitsfunktionen',
    'pay.security.bankLevelEncryption': 'Bank-Level-Verschlüsselung',
    'pay.security.bankLevelEncryptionDesc': 'Alle Transaktionen sind mit branchenüblicher Verschlüsselung geschützt',
    'pay.security.multiplePaymentOptions': 'Mehrere Zahlungsoptionen',
    'pay.security.multiplePaymentOptionsDesc': 'Wählen Sie aus Karten, Bankkonten, PayPal und mehr',
    'pay.security.pciCompliant': 'PCI-Konform',
    'pay.security.pciCompliantDesc': 'Wir erfüllen die höchsten Sicherheitsstandards für die Zahlungsabwicklung',
    'pay.continueOnMobile': 'Auf Mobilgerät Fortsetzen',
    'pay.continueOnMobileDesc': 'Scannen Sie den QR-Code mit Ihrem Telefon, um die Zahlung auf dem Mobilgerät abzuschließen',
    'pay.usePhoneCamera': 'Verwenden Sie die Kamera Ihres Telefons, um den QR-Code zu scannen',
    'pay.guestCheckout.title': 'Gast-Checkout Verfügbar',
    'pay.guestCheckout.description': 'Als Gast fortfahren, um Zahlungen ohne Kontoerstellung zu tätigen',
  },
  ro: {
    'pay.pageTitle': 'Creează Plată',
    'pay.pageTitleRecipient': 'Plătește {{name}}',
    'pay.loadingPayee': 'Se încarcă informațiile beneficiarului...',
    'pay.merchantNotInMarketplace': 'Comerciantul nu a fost găsit pe piață',
    'pay.paymentCurrency': 'Moneda Plății',
    'pay.orderSummary': 'Rezumatul Comenzii',
    'pay.paymentComplete': 'Plata Completă',
    'pay.paymentDeliveredSuccessfully': 'Plata Livrată cu Succes',
    'pay.paymentDeliveredToInbox': 'Plata Livrată în Inbox',
    'pay.recentlyCreatedInvoice': 'Factură Creată Recent',
    'pay.recentlyCreatedToken': 'Token Creat Recent',
    'pay.paymentDeliveredTo': 'Plata a fost livrată către {{name}}',
    'pay.yourPaymentDelivered': 'Plata dvs. de {{amount}} {{currency}} a fost livrată către {{name}}',
    'pay.recipientWillReview': '{{name}} va examina și accepta plata dvs.',
    'pay.invoiceCreatedSuccessfully': 'Factura a fost creată cu succes',
    'pay.tokenCreatedSuccessfully': 'Tokenul a fost creat cu succes',
    'pay.paymentSuccessful': 'Plată Reușită',
    'pay.makeAnotherPayment': 'Efectuează Altă Plată',
    'pay.paymentInInbox': 'Plată în Inbox',
    'pay.recipientHasControl': '{{name}} are controlul asupra momentului acceptării acestei plăți',
    'pay.paymentDeposited': 'Plată Depusă',
    'pay.yourPaymentDepositedTo': 'Plata dvs. de {{amount}} {{currency}} a fost depusă către {{name}}',
    'pay.messageSentWithPayment': 'Mesaj trimis cu plata',
    'pay.autoPaymentMode.title': 'Modul de Plată Automată',
    'pay.autoPaymentMode.creatingTokenFor': 'Se creează token pentru {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token trimis către fereastra părinte',
    'pay.security.title': 'Caracteristici de Securitate',
    'pay.security.bankLevelEncryption': 'Criptare la Nivel Bancar',
    'pay.security.bankLevelEncryptionDesc': 'Toate tranzacțiile sunt protejate cu criptare de standard industrial',
    'pay.security.multiplePaymentOptions': 'Opțiuni Multiple de Plată',
    'pay.security.multiplePaymentOptionsDesc': 'Alegeți dintre carduri, conturi bancare, PayPal și altele',
    'pay.security.pciCompliant': 'Conform PCI',
    'pay.security.pciCompliantDesc': 'Ne conformăm celor mai înalte standarde de securitate pentru procesarea plăților',
    'pay.continueOnMobile': 'Continuă pe Mobil',
    'pay.continueOnMobileDesc': 'Scanați codul QR cu telefonul pentru a finaliza plata pe mobil',
    'pay.usePhoneCamera': 'Folosiți camera telefonului pentru a scana codul QR',
    'pay.guestCheckout.title': 'Checkout Invitat Disponibil',
    'pay.guestCheckout.description': 'Continuați ca invitat pentru a efectua plăți fără a crea un cont',
  },
  sr: {
    'pay.pageTitle': 'Креирај Плаћање',
    'pay.pageTitleRecipient': 'Плати {{name}}',
    'pay.loadingPayee': 'Учитавање информација о примаоцу...',
    'pay.merchantNotInMarketplace': 'Трговац није пронађен на тржишту',
    'pay.paymentCurrency': 'Валута Плаћања',
    'pay.orderSummary': 'Резиме Поруџбине',
    'pay.paymentComplete': 'Плаћање Завршено',
    'pay.paymentDeliveredSuccessfully': 'Плаћање Успешно Достављено',
    'pay.paymentDeliveredToInbox': 'Плаћање Достављено у Инбокс',
    'pay.recentlyCreatedInvoice': 'Недавно Креирана Фактура',
    'pay.recentlyCreatedToken': 'Недавно Креиран Токен',
    'pay.paymentDeliveredTo': 'Плаћање достављено {{name}}',
    'pay.yourPaymentDelivered': 'Ваше плаћање од {{amount}} {{currency}} је достављено {{name}}',
    'pay.recipientWillReview': '{{name}} ће прегледати и прихватити ваше плаћање',
    'pay.invoiceCreatedSuccessfully': 'Фактура је успешно креирана',
    'pay.tokenCreatedSuccessfully': 'Токен је успешно креиран',
    'pay.paymentSuccessful': 'Успешно Плаћање',
    'pay.makeAnotherPayment': 'Направи Још Једно Плаћање',
    'pay.paymentInInbox': 'Плаћање у Инбоксу',
    'pay.recipientHasControl': '{{name}} има контролу над када ће прихватити ово плаћање',
    'pay.paymentDeposited': 'Плаћање Депоновано',
    'pay.yourPaymentDepositedTo': 'Ваше плаћање од {{amount}} {{currency}} је депоновано {{name}}',
    'pay.messageSentWithPayment': 'Порука послата са плаћањем',
    'pay.autoPaymentMode.title': 'Режим Аутоматског Плаћања',
    'pay.autoPaymentMode.creatingTokenFor': 'Креирање токена за {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Токен послат у родитељски прозор',
    'pay.security.title': 'Функције Безбедности',
    'pay.security.bankLevelEncryption': 'Банкарско Шифровање',
    'pay.security.bankLevelEncryptionDesc': 'Све трансакције су заштићене шифровањем индустријског стандарда',
    'pay.security.multiplePaymentOptions': 'Више Опција Плаћања',
    'pay.security.multiplePaymentOptionsDesc': 'Изаберите између картица, банковних рачуна, ПаиПала и више',
    'pay.security.pciCompliant': 'Усклађено са PCI',
    'pay.security.pciCompliantDesc': 'Испуњавамо највише стандарде безбедности за обраду плаћања',
    'pay.continueOnMobile': 'Настави на Мобилном',
    'pay.continueOnMobileDesc': 'Скенирајте QR код са вашим телефоном да бисте завршили плаћање на мобилном',
    'pay.usePhoneCamera': 'Користите камеру вашег телефона да бисте скенирали QR код',
    'pay.guestCheckout.title': 'Гостова Каса Доступна',
    'pay.guestCheckout.description': 'Наставите као гост да бисте извршили плаћања без креирања налога',
  },
  pl: {
    'pay.pageTitle': 'Utwórz Płatność',
    'pay.pageTitleRecipient': 'Zapłać {{name}}',
    'pay.loadingPayee': 'Ładowanie informacji o odbiorcy...',
    'pay.merchantNotInMarketplace': 'Sprzedawca nie znaleziony na rynku',
    'pay.paymentCurrency': 'Waluta Płatności',
    'pay.orderSummary': 'Podsumowanie Zamówienia',
    'pay.paymentComplete': 'Płatność Zakończona',
    'pay.paymentDeliveredSuccessfully': 'Płatność Dostarczona Pomyślnie',
    'pay.paymentDeliveredToInbox': 'Płatność Dostarczona do Skrzynki',
    'pay.recentlyCreatedInvoice': 'Ostatnio Utworzona Faktura',
    'pay.recentlyCreatedToken': 'Ostatnio Utworzony Token',
    'pay.paymentDeliveredTo': 'Płatność dostarczona do {{name}}',
    'pay.yourPaymentDelivered': 'Twoja płatność {{amount}} {{currency}} została dostarczona do {{name}}',
    'pay.recipientWillReview': '{{name}} przejrzy i zaakceptuje Twoją płatność',
    'pay.invoiceCreatedSuccessfully': 'Faktura utworzona pomyślnie',
    'pay.tokenCreatedSuccessfully': 'Token utworzony pomyślnie',
    'pay.paymentSuccessful': 'Płatność Pomyślna',
    'pay.makeAnotherPayment': 'Wykonaj Kolejną Płatność',
    'pay.paymentInInbox': 'Płatność w Skrzynce',
    'pay.recipientHasControl': '{{name}} ma kontrolę nad tym, kiedy zaakceptować tę płatność',
    'pay.paymentDeposited': 'Płatność Zdeponowana',
    'pay.yourPaymentDepositedTo': 'Twoja płatność {{amount}} {{currency}} została zdeponowana u {{name}}',
    'pay.messageSentWithPayment': 'Wiadomość wysłana z płatnością',
    'pay.autoPaymentMode.title': 'Tryb Automatycznej Płatności',
    'pay.autoPaymentMode.creatingTokenFor': 'Tworzenie tokenu dla {{currency}} {{amount}}',
    'pay.autoPaymentMode.tokenSentToParent': 'Token wysłany do okna nadrzędnego',
    'pay.security.title': 'Funkcje Bezpieczeństwa',
    'pay.security.bankLevelEncryption': 'Szyfrowanie na Poziomie Bankowym',
    'pay.security.bankLevelEncryptionDesc': 'Wszystkie transakcje są chronione szyfrowaniem standardu branżowego',
    'pay.security.multiplePaymentOptions': 'Wiele Opcji Płatności',
    'pay.security.multiplePaymentOptionsDesc': 'Wybierz spośród kart, kont bankowych, PayPal i innych',
    'pay.security.pciCompliant': 'Zgodne z PCI',
    'pay.security.pciCompliantDesc': 'Spełniamy najwyższe standardy bezpieczeństwa przetwarzania płatności',
    'pay.continueOnMobile': 'Kontynuuj na Urządzeniu Mobilnym',
    'pay.continueOnMobileDesc': 'Zeskanuj kod QR telefonem, aby zakończyć płatność na urządzeniu mobilnym',
    'pay.usePhoneCamera': 'Użyj aparatu telefonu, aby zeskanować kod QR',
    'pay.guestCheckout.title': 'Kasa Gościa Dostępna',
    'pay.guestCheckout.description': 'Kontynuuj jako gość, aby dokonywać płatności bez tworzenia konta',
  },
};

